import { Heading, Text, VStack, Image } from '@chakra-ui/react';
import React, { useState } from 'react';

import { utils as commonUtils } from '@finley-technologies/common';

import { Alert } from '~/packages/common-frontend/components/Alert';
import mainLogo from '~/packages/common-frontend/images/Logo-square.svg';
import { useDataMetadataContext } from '~/valleyBank/domains/page/hooks/DataMetadataContext';

// Fragments
const ValleyBankCalcAgentErrorFallbackPage = () => {
  const metadataContext = useDataMetadataContext();
  const errors = metadataContext.metadata?.details ?? [];
  return (
    <VStack
      w="100%"
      h="100%"
      flexDir="column"
      alignItems="flex-start"
      padding={['1.5rem', '1.5rem', '1.5rem', '2.5rem']}
    >
      <VStack spacing="16px" alignItems="flex-start">
        <Heading as="h1">Calculation Error</Heading>
        <Text>{`We encountered ${
          errors.length > 0 ? 'errors' : 'an error'
        } while recalculating the ${
          metadataContext.isPreview ? 'preview' : 'portfolio'
        }. Contact your Finley Customer Service Manager for support.`}</Text>
      </VStack>
      <VStack spacing="16px">
        {errors.map((error) => (
          <Alert key={error} status="error">
            <Text>{error}</Text>
          </Alert>
        ))}
      </VStack>
    </VStack>
  );
};

const ValleyBankPipelineInProgress = () => {
  const metadataContext = useDataMetadataContext();
  const [logoLoaded, setLogoLoaded] = useState(false);
  return (
    <VStack w="100%" h="100%" flexDir="column" p="100px 200px" spacing="64px">
      <VStack spacing="16px">
        <Heading as="h1">Check back in a few minutes</Heading>
        <Text>The calculations are updating.</Text>
      </VStack>
      <Image
        src={mainLogo}
        alt="Logo"
        width={{ base: '100px', sm: '140px', md: '180px' }}
        cursor="pointer"
        display={logoLoaded ? 'block' : 'none'}
        h="auto"
        onLoad={() => {
          setLogoLoaded(true);
        }}
      />
      {!commonUtils.EnvUtils.isCustomerFacing() && (
        <Text fontSize="sm" color="gray.500" textAlign="center">
          {metadataContext.metadata?.details.join(',') ?? ''}
        </Text>
      )}
    </VStack>
  );
};

// Exports
type ValleyBankLayoutProps = { children: React.ReactNode };
export const ValleyBankLayout = ({ children }: ValleyBankLayoutProps) => {
  const { status } = useDataMetadataContext();
  if (status === 'error') return <ValleyBankCalcAgentErrorFallbackPage />;
  if (status === 'in-progress') return <ValleyBankPipelineInProgress />;
  return <>{children}</>;
};
